import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";
import { ITestimonialsState } from "./types";

const initialState: ITestimonialsState = {
  testimonials: {},
  testimonialDetail: {},
  addTestimonial: {},
  updateTestimonial: {},
  deleteTestimonial: {},
};

const slice = createSlice({
  name: "testimonials",
  initialState,
  reducers: {
    // Get all testimonials
    getTestimonials(state) {
      state.testimonials.status = RequestStatus.RUNNING;
    },
    getTestimonialsSuccess(state, action) {
      state.testimonials.status = RequestStatus.SUCCESS;
      state.testimonials.data = action.payload;
    },
    getTestimonialsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.testimonials.status = RequestStatus.ERROR;
      state.testimonials.error = action.payload;
    },

    // Get testimonial detail by ID
    getTestimonialDetail(state, action: PayloadAction<{ id: number | string }>) {
      state.testimonialDetail.status = RequestStatus.RUNNING;
    },
    getTestimonialDetailSuccess(state, action) {
      state.testimonialDetail.status = RequestStatus.SUCCESS;
      state.testimonialDetail.data = action.payload;
    },
    getTestimonialDetailFailed(state, action: PayloadAction<IRequestFailed>) {
      state.testimonialDetail.status = RequestStatus.ERROR;
      state.testimonialDetail.error = action.payload;
    },
    clearTestimonialDetail(state) {
      state.testimonialDetail = {};
    },

    // Add testimonial
    addTestimonial(state, action: PayloadAction<any>) {
      state.addTestimonial.status = RequestStatus.RUNNING;
    },
    addTestimonialSuccess(state, action) {
      state.addTestimonial.status = RequestStatus.SUCCESS;
      state.addTestimonial.data = action.payload;
    },
    addTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addTestimonial.status = RequestStatus.ERROR;
      state.addTestimonial.error = action.payload;
    },

    // Update testimonial
    updateTestimonial(
      state,
      action: PayloadAction<{ id: number | string; data: any }>
    ) {
      state.updateTestimonial.status = RequestStatus.RUNNING;
    },
    updateTestimonialSuccess(state, action) {
      state.updateTestimonial.status = RequestStatus.SUCCESS;
      state.updateTestimonial.data = action.payload;
    },
    updateTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateTestimonial.status = RequestStatus.ERROR;
      state.updateTestimonial.error = action.payload;
    },

    // Delete testimonial
    deleteTestimonial(state, action: PayloadAction<{ id: number | string }>) {
      state.deleteTestimonial.status = RequestStatus.RUNNING;
    },
    deleteTestimonialSuccess(state, action) {
      state.deleteTestimonial.status = RequestStatus.SUCCESS;
      state.deleteTestimonial.data = action.payload;
    },
    deleteTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteTestimonial.status = RequestStatus.ERROR;
      state.deleteTestimonial.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  getTestimonials,
  getTestimonialsSuccess,
  getTestimonialsFailed,
  getTestimonialDetail,
  getTestimonialDetailSuccess,
  getTestimonialDetailFailed,
  clearTestimonialDetail,
  addTestimonial,
  addTestimonialSuccess,
  addTestimonialFailed,
  updateTestimonial,
  updateTestimonialSuccess,
  updateTestimonialFailed,
  deleteTestimonial,
  deleteTestimonialSuccess,
  deleteTestimonialFailed,
} = slice.actions;
